/* oxlint-disable n/no-process-env */

export const AppConfig = {
  isProduction: process.env.NODE_ENV === "production",
  isDevServer: process.env.NEXT_PUBLIC_SERVER === "development",
  api: {
    url: process.env.NEXT_PUBLIC_API_URL as string,
  },
  i18nextDebug: true,
  log: {
    level: process.env.NEXT_PUBLIC_LOG_LEVEL ?? "error",
  },
  sentry: {
    enabled: process.env.NODE_ENV === "production",
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN as string,
    environment: process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT as string,
    tracesSampleRate: parseFloat(process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE ?? "1.0"),
    replaysSessionSampleRate: parseFloat(process.env.NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? "0.1"),
    replaysOnErrorSampleRate: parseFloat(process.env.NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE ?? "1.0"),
  },
  launchDarkly: {
    clientSideId: process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_SIDE_ID as string,
  },

  googleAnalytics: {
    measurementId: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_MEASUREMENT_ID as string | undefined,
  },
  media: {
    uploadSecret: process.env.NEXT_PUBLIC_MEDIA_UPLOAD_SECRET as string,
  },
  version: process.env.NEXT_PUBLIC_RELEASE as string,
  streamer: {
    url: process.env.NEXT_PUBLIC_LD_STREAMER_URL as string,
  },
};
